<template>
  <div class="modal fade show d-block" tabindex="-1" role="dialog" style="background-color: rgba(0,0,0,0.5);">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Reabrir Lote TISS{{ batch ? ` - ${batch.batch_number}` : '' }}</h5>
          <button type="button" class="btn-close" @click="closeModal"></button>
        </div>
        <div class="modal-body">
          <div class="alert alert-info" role="alert">
            <i class="bi bi-info-circle"></i>
            Esta ação irá reverter o lote para status "Rascunho". As guias permanecem no lote; você poderá remover ou adicionar guias e fechar novamente quando necessário.
          </div>

          <div class="row">
            <div class="col-12">
              <label class="form-label">Observações da Reabertura</label>
              <textarea
                v-model="form.observations"
                class="form-control"
                rows="4"
                placeholder="Descreva o motivo da reabertura do lote..."
                maxlength="1000"
                :class="{ 'is-invalid': errors.observations }"
              ></textarea>
              <div class="invalid-feedback">{{ errors.observations ? errors.observations[0] : '' }}</div>
              <small class="text-muted">{{ form.observations.length }}/1000 caracteres</small>
            </div>
          </div>

          <!-- Informações do lote -->
          <div class="row mt-4" v-if="batch">
            <div class="col-12">
              <h6 class="text-muted mb-3">Informações do Lote</h6>
              <div class="border rounded p-3 bg-light">
                <div class="row">
                  <div class="col-md-6">
                    <strong>Número:</strong> {{ batch.batch_number }}
                  </div>
                  <div class="col-md-6">
                    <strong>Tipo:</strong> {{ batchTypeLabel(batch.batch_type) }}
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-md-4">
                    <strong>Status Atual:</strong> {{ statusLabel(batch.status) }}
                  </div>
                  <div class="col-md-4">
                    <strong>Total de Guias:</strong> {{ batch.total_guides }}
                  </div>
                  <div class="col-md-4">
                    <strong>Valor Total:</strong> R$ {{ formatCurrency(batch.total_amount) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="closeModal">Cancelar</button>
          <button type="button" class="btn btn-warning" @click="confirmReopen" :disabled="loading">
            <i v-if="loading" class="fas fa-spinner fa-spin me-2"></i>
            <i v-else class="bi bi-arrow-counterclockwise me-2"></i>
            Confirmar Reabertura
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "@/helpers/http";
import Alert from "@/helpers/alert";

export default {
  name: "ModalTissBatchReopen",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    batch: {
      type: Object,
      required: false,
      default: null
    }
  },
  emits: ['close', 'reopened'],
  data() {
    return {
      form: {
        observations: ''
      },
      errors: {},
      loading: false
    };
  },
  watch: {
    show(newVal) {
      if (newVal) {
        this.resetForm();
      }
    }
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
    resetForm() {
      this.form = {
        observations: ''
      };
      this.errors = {};
      this.loading = false;
    },
    confirmReopen() {
      if (!this.batch) {
        return;
      }

      this.loading = true;

      const body = {};
      if (this.form.observations.trim()) {
        body.observations = this.form.observations.trim();
      }

      http.patch(`/places/${this.$store.state.auth.place.id_place}/tiss-batches/${this.batch.id}/reopen`, body)
      .then((response) => {
        const res = response.data || response;
        Alert.success(res.message || 'Lote reaberto com sucesso!');
        this.$emit('reopened', { message: res.message, batch: res.batch, tax_settlements_removed: res.tax_settlements_removed });
        this.closeModal();
      })
      .catch((error) => {
        console.error('Erro ao reabrir lote:', error);
        const data = error.response?.data;
        if (error.response?.status === 400 && data?.message) {
          Alert.error(data.message);
          return;
        }
        if (error.response?.status === 403 && data?.error) {
          Alert.error(data.error);
          return;
        }
        if (data?.errors) {
          this.errors = data.errors;
        } else {
          Alert.error(data?.error || data?.message || 'Erro ao reabrir lote. Tente novamente.');
        }
      })
      .finally(() => {
        this.loading = false;
      });
    },
    formatCurrency(value) {
      if (!value) return '0,00';
      return parseFloat(value).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },
    batchTypeLabel(type) {
      const labels = {
        tiss: 'Recebimento (TISS)',
        payment: 'Pagamento'
      };
      return labels[type] || type;
    },
    statusLabel(status) {
      const labels = {
        draft: 'Rascunho',
        closed: 'Fechado',
        sent: 'Enviado',
        processed: 'Processado',
        cancelled: 'Cancelado'
      };
      return labels[status] || status;
    }
  }
};
</script>

<style scoped>
.modal {
  z-index: 1050;
}
</style>
